<template>
	<div class="box">
		<div class="col sm-16 md-12 download-item__content">
			<div class="download-item__title-lockup">
				<h3 class="download-item__title">{{ displayTitle }}</h3>
				<a
					class="download-item__title-link"
					v-if="titleLink && titleLinkHref && titleLink.text"
					:href="titleLinkHref"
					target="_blank"
					rel="noopener noreferrer"
				>
					{{ titleLink.text }}
				</a>
			</div>

			<p class="download-item__desc" v-if="description">{{ description }}</p>

			<div class="download-item__actions">
				<a
					class="button button--black download-item__button"
					:href="link"
					target="_blank"
					title="Opens a PDF"
					rel="noopener noreferrer"
					@click="trackItemDownload"
				>
					Download PDF
					<span aria-hidden="true" class="icon icon-download" />
				</a>
				<a
					class="download-item__extra-dl cta cta-icon"
					v-if="extraDownload"
					:href="extraDownloadHref"
					target="_blank"
					:title="
						extraDownload.ariaTitle ? extraDownload.ariaTitle : 'Opens a PDF'
					"
					rel="noopener noreferrer"
				>
					{{ extraDownload.text }}
					<span aria-hidden="true" class="icon icon-download" />
				</a>
			</div>
		</div>
		<!-- the image is also a download link but a duplicate of the download button
			so we should hide it from screen readers since it's only presentational -->
		<div v-if="img" class="col large-med-only md-4" aria-hidden="true">
			<a :href="link" target="_blank" rel="noopener noreferrer">
				<img class="download-item__img" :src="img" alt="" />
			</a>
		</div>
	</div>
</template>

<script>
import { adobeLaunch } from "vg-fas-adobe-launch";

export default {
	name: "DownloadSingleSelectItem",
	props: {
		displayTitle: {
			type: String,
			required: true
		},
		titleLink: {
			type: Object
		},
		description: {
			type: String
		},
		link: {
			type: String,
			required: true
		},
		extraDownload: {
			type: Object
		},
		img: {
			type: String
		},
		fundId: {
			type: String
		},
		litId: {
			type: String
		}
	},
	computed: {
		titleLinkHref() {
			return this.titleLink ? this.titleLink.location : null;
		},

		extraDownloadHref() {
			return this.extraDownload ? this.extraDownload.location : null;
		}
	},
	methods: {
		trackItemDownload() {
			const fileName = this.link.substring(
				this.link.lastIndexOf("/") + 1,
				this.link.lastIndexOf(".")
			);
			const litIdTrack = this.litId ? `lit:${this.litId}` : null;
			adobeLaunch.trackContentDownloaded(
				`pdf:${fileName}`,
				litIdTrack,
				this.fundId
			);
		}
	}
};
</script>

<style lang="scss" scoped>
// https://github.com/philipwalton/flexbugs/issues/3
// can not apply padding to something that has flex-basis applied (our grid)
// so need to apply to children instead
.download-item__title-lockup,
.download-item__desc,
.download-item__actions {
	padding-right: 20px;
}

.download-item__title-lockup {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-bottom: 16px;
}

.download-item__title-link {
	@include p3;

	color: $color--black;
	text-decoration: underline;
}

.download-item__title {
	@include h3;

	margin-top: 0;
}

.download-item__desc {
	@include p2;

	margin-bottom: 40px;
}

.download-item__button {
	margin-right: 10px;

	@include to-md() {
		display: block;
	}
}
.download-item__extra-dl {
	color: $color--red;
	display: inline-block;
}

.download-item__img {
	display: block;
	width: 100%;
}
</style>
